module.exports = __webpack_public_path__ + "static/bg_code-0365a06ad8e29d639c9bdc7303703117.jpg";